import * as React from 'react';
import { Popover as AriaPopover } from 'react-aria-components';

import { cx } from '../../utils/cx';

import type { PopoverProps as AriaPopoverProps } from 'react-aria-components';

interface IPopoverProps extends AriaPopoverProps, React.RefAttributes<HTMLElement> {
  size: 'sm' | 'md';
}

const Popover = (props: IPopoverProps) => {
  return (
    <AriaPopover
      placement="bottom"
      containerPadding={0}
      offset={4}
      {...props}
      // Width/anchor come from react-aria's `--trigger-width` / `--trigger-anchor-point`,
      // which it only populates when the trigger is its own (Select/ComboBox) descendant —
      // do not pass an explicit `triggerRef`, or positioning silently falls back to (0,0).
      className={(state) =>
        cx(
          'max-h-64! w-(--trigger-width) origin-(--trigger-anchor-point) bg-primary ring-secondary_alt outline-hidden overflow-y-auto overflow-x-hidden rounded-lg py-1 shadow-lg ring-1 will-change-transform',

          state.isEntering &&
            'animate-in fade-in placement-right:slide-in-from-left-0.5 placement-top:slide-in-from-bottom-0.5 placement-bottom:slide-in-from-top-0.5 duration-150 ease-out',
          state.isExiting &&
            'animate-out fade-out placement-right:slide-out-to-left-0.5 placement-top:slide-out-to-bottom-0.5 placement-bottom:slide-out-to-top-0.5 duration-100 ease-in',
          props.size === 'md' && 'max-h-80!',

          typeof props.className === 'function' ? props.className(state) : props.className
        )
      }
    />
  );
};

export default Popover;
